export const getRelease = () => {
  // build time for webpack plugin || runtime for client
  const sha = process.env.CI_COMMIT_SHA || process.env.ciCommitSha
  const tag = process.env.CI_COMMIT_TAG || process.env.ciCommitTag

  if (tag) return tag
  if (sha) return sha
  return false
}
